<template>
  <page-view :title="title">
    <iframe :src="src" frameborder="0" scrolling="auto" class="frame"></iframe>
  </page-view>
</template>

<script>
import { PageView } from '@/layouts'

export default {
  name: 'IframeView',
  components: {
    PageView
  },
  created () {
    this.title = this.$route.meta.title
    this.src = this.$route.meta.originPath
  },
  data () {
    return {
      title: '',
      src: 'about:blank',
      onResizeHandler: null
    }
  },
  methods: {}
}
</script>

<style scoped>
.frame {
  width: 100%;
  height: calc(100vh - 215px);
}
</style>
